import styled from 'styled-components/macro';

export const SeparatorWrapper = styled.div`
    margin-bottom: ${props => props.marginBottom ? `${props.marginBottom}` : '35px'};
    margin-top:  ${props => props.marginTop ? `${props.marginTop}` : ''};
`;